import React from 'react';
import FilterReviews from '../filter/Filter';

const HeaderDesktop = ({ data }) => (
    <header>
        <FilterReviews fetchReviews={data.general_reviews}
            type={data.reviews_type}
            lastStar={data.lastStar}/>

        <h2 className="alt">{data.title}</h2>

        <span className="user-rating">
            <span className={`star-rating-s15 rate-${data.rating_ten}`}></span>
            <span className="total-rating-out-five">
                {data.rating_five}
            </span>
            {!data.hasGigId && <span className="total-rating">
                ( {data.total_count} )
            </span>}
        </span>
    </header>
);

export default HeaderDesktop;



// WEBPACK FOOTER //
// ./src/reviews/headers/HeaderDesktop.js